import { render, staticRenderFns } from "./GroupDetailExamine.vue?vue&type=template&id=350c3a71&scoped=true"
import script from "./GroupDetailExamine.vue?vue&type=script&lang=js"
export * from "./GroupDetailExamine.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailExamine.vue?vue&type=style&index=0&id=350c3a71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c3a71",
  null
  
)

export default component.exports